import { Loader as MtLoader } from "@mantine/core";
import styled from "styled-components";

export const Loader = styled(MtLoader)`
    stroke: ${({ theme }) => theme.color.azure};
`;
